import { ApiParameters } from "../api-parameters";
import { ApiPutRequest } from "../api-put-request";

export class UpdateTicketOwnershipRequest extends ApiPutRequest
{
    public constructor(playerId: number, ticketNumber: number, ticketLetter: string, paymentMethodId: any, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
                .addQueryParameter('playerid', playerId)
                .addQueryParameter('ticketNumber', ticketNumber)
                .addQueryParameter('ticketLetter', ticketLetter)
                .addQueryParameter('paymentMethodId', paymentMethodId);
        super('subscription/put',
                parameters, 
                null, 
                null,
                webapiBasepath   
            );
    }
}